import type { ScriptElement, VideoContent } from '../../schema';

/**
 * Inline HTML5 video on the chalkboard. Autoplay deliberately disabled —
 * the lesson narration drives pacing; teachers can press play if the
 * authored slide expects video playback.
 */
export function VideoElement({ element, fill }: { element: ScriptElement; fill?: boolean }) {
  const c = element.content as VideoContent | undefined;
  const style: React.CSSProperties = {
    width: fill ? '100%' : '100%',
    height: fill ? '100%' : 'auto',
    maxWidth: '100%',
    borderRadius: 10,
    border: '1px solid rgba(60, 45, 25, 0.15)',
    boxShadow: '0 6px 18px rgba(60, 45, 25, 0.12)',
    background: 'rgba(255, 255, 255, 0.45)',
  };
  if (!c?.src) {
    return (
      <div style={style} className="grid place-items-center text-[12px] italic" >
        <span style={{ color: 'rgba(60, 45, 25, 0.45)' }}>(no video source)</span>
      </div>
    );
  }
  return (
    <video
      controls
      // Autoplay when authored to — the player only mounts revealed elements, so
      // playback starts when the reveal fires.
      autoPlay={!!c.autoplay}
      preload="metadata"
      poster={c.poster}
      src={c.src}
      style={style}
      className="block object-contain"
    />
  );
}
